import { useQuery } from '@tanstack/react-query';
import { api_host, api_auth } from '../common/globals/constants';
import { getApiKeys } from '../utils/fns/get-api-keys';

const fetchDisponibilidadDetalle = async (user_id, token, objetivoId) => {
  const url = `${api_host}/reporte/online/indicadores/getDetalleDisponibilidadConsolidada/?user=${user_id}&key=${api_auth}&objetivoId=${objetivoId}&horarioId=0&t=d&token=${token}&nodoId=0&_=${new Date().getTime()}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return response.json();
};

export const useDisponibilidadDetalle = (objetivoId, options = {}) => {
  const {user, token} =getApiKeys()

  return useQuery({
    queryKey: ['disponibilidadDetalle', user, objetivoId],
    queryFn: () => fetchDisponibilidadDetalle(user, token, objetivoId),
    enabled: !!user && !!token && !!objetivoId,
    refetchInterval: 300000,
    ...options
  });
};
